import {
  VITALITY_MAX,
  VITALITY_DECAY_BASE,
  VITALITY_RESTORE_PER_S,
  VITALITY_LOW_THRESHOLD,
} from '@/domain/world/types';

export {
  VITALITY_MAX,
  VITALITY_DECAY_BASE,
  VITALITY_RESTORE_PER_S,
  VITALITY_LOW_THRESHOLD,
};

/** Decay no mundo. Retorna nova vitalidade clamped em [0, VITALITY_MAX]. */
export function applyDecay(vitality: number, dtSec: number, exposureMult: number): number {
  if (dtSec <= 0) return vitality;
  const next = vitality - VITALITY_DECAY_BASE * exposureMult * dtSec;
  return clampVitality(next);
}

/** Restore em casa. */
export function applyRestore(vitality: number, dtSec: number): number {
  if (dtSec <= 0) return vitality;
  const next = vitality + VITALITY_RESTORE_PER_S * dtSec;
  return clampVitality(next);
}

export function clampVitality(v: number): number {
  if (Number.isNaN(v)) return 0;
  return Math.max(0, Math.min(VITALITY_MAX, v));
}

export function isLow(vitality: number): boolean {
  return vitality <= VITALITY_LOW_THRESHOLD;
}

export function isCritical(vitality: number): boolean {
  return vitality <= 5;
}
